module.exports = __webpack_public_path__ + "static/2-27cd02a95d4d6a67d3d286c05533ea46.jpeg";